import React from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';

interface Props {
  isChecked: boolean;
  marginRight?: number;
}

const ReportCheckBox = ({ isChecked, marginRight = 0 }: Props) => {
  return (
    <Wrapper marginRight={marginRight}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isChecked ? (
          <>
            <rect width="22" height="22" rx="4" fill="#FF8D00" />
            <g clipPath="url(#clip0_3378_52888)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9633 5.81458C15.7311 5.83212 15.525 5.92307 15.3653 6.07857C15.3414 6.10184 15.2744 6.17812 15.2164 6.24808C15.1584 6.31804 13.6716 8.11732 11.9124 10.2465C10.1532 12.3756 8.71046 14.1214 8.70622 14.1259C8.69906 14.1335 8.62878 14.0444 7.71451 12.8685C7.17331 12.1724 6.71258 11.5819 6.69067 11.5563C6.53618 11.3754 6.32521 11.2671 6.07051 11.2379C5.77992 11.2046 5.50387 11.3009 5.28881 11.5108C5.20188 11.5956 5.142 11.6779 5.09396 11.7785C5.02658 11.9195 4.99631 12.071 5.00156 12.2409C5.00779 12.4424 5.06386 12.6026 5.18713 12.7713C5.21912 12.815 7.29929 15.4899 7.35403 15.5577C7.40303 15.6183 7.5179 15.7341 7.57864 15.784C8.0146 16.1425 8.57816 16.2699 9.12492 16.1335C9.45932 16.05 9.77213 15.8579 10.0038 15.5937C10.0451 15.5465 16.7301 7.45789 16.7906 7.38192C16.8943 7.25151 16.9607 7.10558 16.9887 6.94648C17.0002 6.88059 17.0025 6.74041 16.9932 6.66437C16.9649 6.43317 16.8738 6.24877 16.7091 6.08951C16.5028 5.89011 16.241 5.79362 15.9633 5.81458Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_3378_52888">
                <rect
                  width="12"
                  height="12"
                  fill="white"
                  transform="translate(5 5)"
                />
              </clipPath>
            </defs>
          </>
        ) : (
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            rx="3"
            stroke={theme.color.gray100}
            strokeWidth="2"
          />
        )}
      </svg>
    </Wrapper>
  );
};

export default ReportCheckBox;

const Wrapper = styled.div<{ marginRight: number }>`
  display: flex;
  margin-right: ${({ marginRight }) => marginRight}px;
`;
